"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8368],{

/***/ 34270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30259);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: ",
        "px;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n  padding-bottom: ",
        "px;\n  color: ",
        ";\n  text-align: center;\n  line-height: 135%;\n  font-size: ",
        "px;\n\n  i {\n    margin-bottom: ",
        "px;\n  }\n  svg {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var emptyCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxxlarge */ .Ki.xxxlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, theme.var.gray400, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.large */ .Ki.large, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.large */ .Ki.large);
};
var Empty = function(param) {
    var className = param.className, empty = param.empty, query = param.query, _hideIcon = param.hideIcon, hideIcon = _hideIcon === void 0 ? false : _hideIcon, children = param.children;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.u)();
    var isCheming = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_4__/* .useGlobalContext */ .bN)().isCheming;
    var isQueryDataEmpty = query ? query.isFetched && query.count === 0 : false;
    if (isQueryDataEmpty || empty) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
            css: emptyCSS,
            className: className,
            "data-test": _constants__WEBPACK_IMPORTED_MODULE_3__/* .DATA_TEST.EMPTY */ .AY.EMPTY,
            children: [
                hideIcon ? null : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
                    children: !isCheming ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Chatie */ .Tq,
                        size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.xlarge */ .u8.xlarge,
                        color: theme.var.gray300
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "33",
                        height: "39",
                        viewBox: "0 0 33 39",
                        fill: "none",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M6.28125 29.8817C7.244 28.9849 8.75295 28.1772 11.1333 28.1772C13.1735 28.1772 14.8738 29.0656 16.523 29.9264C18.1084 30.7531 19.5876 31.1527 21.7597 31.1527C24.4566 31.1527 26.2929 30.3939 26.7179 30.0433C26.7179 30.0433 19.2943 36.9037 16.9969 37.1992C14.6995 37.4946 7.28013 31.7924 6.28337 29.8839L6.28125 29.8817Z",
                                fill: "#D8D8D8"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M13.9451 6.39503H18.9161L21.0478 3.24321C21.7087 2.33783 21.577 1.02015 20.6631 0.374054C20.3294 0.138145 19.932 0 19.5048 0H13.5222C13.0121 0 12.5424 0.197654 12.1705 0.527075C11.4118 1.20505 11.3459 2.37609 11.924 3.21558L13.9451 6.39503Z",
                                fill: "#D8D8D8"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M30.688 14.1371C29.315 12.1627 26.922 10.7749 24.446 10.5198C23.0582 10.3774 21.7108 10.5942 20.4824 11.1255V9.43166H21.4685C21.9722 9.43166 22.3802 9.0236 22.3802 8.51991C22.3802 8.01621 21.9722 7.60815 21.4685 7.60815H11.5307C11.027 7.60815 10.6189 8.01621 10.6189 8.51991C10.6189 9.0236 11.027 9.43166 11.5307 9.43166H12.5891V11.1553C11.3415 10.6006 9.9686 10.3753 8.55316 10.5198C6.07508 10.7749 3.68202 12.1606 2.30908 14.1371C-0.30501 17.8967 -0.0733534 23.006 2.92117 27.4818C6.29611 32.3977 10.1832 35.6961 15.15 37.8597C15.6006 38.0552 16.0469 38.1594 16.5187 38.1679C16.9523 38.1594 17.4007 38.0552 17.8513 37.8597C22.818 35.6961 26.703 32.3977 30.0865 27.4733C33.0725 23.0081 33.3042 17.8967 30.6901 14.1392L30.688 14.1371ZM14.4126 9.43166H18.661V12.2222C18.4803 12.3667 18.2997 12.5155 18.1275 12.677C17.5261 13.2466 17.0564 13.4782 16.506 13.4782H16.4932C15.9428 13.4782 15.4731 13.2466 14.8716 12.677C14.7228 12.5367 14.5677 12.4113 14.4126 12.2859V9.43166ZM28.5754 26.449C25.4024 31.0715 21.7618 34.1659 17.1223 36.1871C16.8949 36.287 16.6717 36.3401 16.5187 36.3444C16.3274 36.3401 16.1043 36.2848 15.8769 36.1871C11.2353 34.1659 7.59678 31.0694 4.43012 26.4575C1.86915 22.6298 1.63112 18.3069 3.80741 15.1764C4.88705 13.6249 6.77643 12.5346 8.74018 12.3327C8.94846 12.3114 9.17374 12.2987 9.41177 12.2987C10.6317 12.2987 12.1874 12.6472 13.6198 14.0032C14.2107 14.5621 15.15 15.3039 16.4932 15.3039H16.506C17.8491 15.3039 18.7906 14.5621 19.3793 14.0032C21.0902 12.3837 22.9753 12.2009 24.259 12.3348C26.2227 12.5367 28.1142 13.627 29.1918 15.1785C31.368 18.3069 31.1279 22.6298 28.5754 26.449Z",
                                fill: "#D8D8D8"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M21.2074 21.0448C21.8788 21.0448 22.423 20.4025 22.423 19.6102C22.423 18.8179 21.8788 18.1757 21.2074 18.1757C20.536 18.1757 19.9917 18.8179 19.9917 19.6102C19.9917 20.4025 20.536 21.0448 21.2074 21.0448Z",
                                fill: "#D8D8D8"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M11.7921 21.0448C12.4635 21.0448 13.0077 20.4025 13.0077 19.6102C13.0077 18.8179 12.4635 18.1757 11.7921 18.1757C11.1207 18.1757 10.5764 18.8179 10.5764 19.6102C10.5764 20.4025 11.1207 21.0448 11.7921 21.0448Z",
                                fill: "#D8D8D8"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M19.2134 23.2167C17.7024 24.6067 15.2456 24.6088 13.7345 23.2167C13.3647 22.8767 12.7887 22.9 12.4466 23.2699C12.1044 23.6397 12.1299 24.2177 12.4997 24.5578C13.5942 25.5673 15.0352 26.071 16.474 26.071C17.9128 26.071 19.3537 25.5673 20.4482 24.5578C20.818 24.2177 20.8435 23.6397 20.5014 23.2699C20.1592 22.9 19.5832 22.8767 19.2134 23.2167Z",
                                fill: "#D8D8D8"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
                    children: children
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Empty);


/***/ }),

/***/ 16482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var react_responsive_carousel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61871);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24123);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9150);
/* harmony import */ var _EFinderImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11247);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n\n  .carousel .slide {\n    background: transparent;\n    padding: 0;\n  }\n\n  .carousel .slider-wrapper {\n    overflow: hidden;\n  }\n\n  .carousel .slider {\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: ",
        "px;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        "px;\n  right: ",
        "px;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: ",
        ";\n  ",
        ";\n  padding: 2px ",
        "px;\n  border-radius: ",
        "px;\n  z-index: 2;\n  pointer-events: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var carouselWrapperCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject());
var imageWrapperCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.medium */ .wU.medium);
var counterCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject2(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, theme.true.white, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.round */ .wU.round);
};
var ImageCarousel = function(param) {
    var images = param.images, onClickImage = param.onClickImage;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    if (images.length === 0) return null;
    if (images.length === 1) {
        var ref1, ref2;
        var img = images[0];
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            css: imageWrapperCSS,
            onClick: function() {
                return onClickImage === null || onClickImage === void 0 ? void 0 : onClickImage(0);
            },
            style: {
                cursor: onClickImage ? "pointer" : undefined
            },
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_EFinderImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                image: img,
                width: ((ref1 = img.attachment) === null || ref1 === void 0 ? void 0 : ref1.width) || 800,
                height: ((ref2 = img.attachment) === null || ref2 === void 0 ? void 0 : ref2.height) || 800,
                layout: "responsive",
                objectFit: "contain"
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        css: carouselWrapperCSS,
        style: {
            cursor: onClickImage ? "pointer" : undefined
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                css: counterCSS,
                children: [
                    currentIndex + 1,
                    "/",
                    images.length
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_responsive_carousel__WEBPACK_IMPORTED_MODULE_1__/* .Carousel */ .lr, {
                showThumbs: false,
                showStatus: false,
                showArrows: false,
                showIndicators: false,
                emulateTouch: true,
                preventMovementUntilSwipeScrollTolerance: true,
                swipeScrollTolerance: 30,
                infiniteLoop: false,
                selectedItem: currentIndex,
                onChange: setCurrentIndex,
                onClickItem: function(index) {
                    return onClickImage === null || onClickImage === void 0 ? void 0 : onClickImage(index);
                },
                children: images.map(function(image, idx) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                        css: imageWrapperCSS,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_EFinderImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                            image: image,
                            width: ((ref = image.attachment) === null || ref === void 0 ? void 0 : ref.width) || 800,
                            height: ((ref1 = image.attachment) === null || ref1 === void 0 ? void 0 : ref1.height) || 800,
                            layout: "responsive",
                            objectFit: "contain"
                        })
                    }, "carousel-img-".concat(image.key || idx));
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageCarousel);


/***/ }),

/***/ 39753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gt": function() { return /* binding */ PaginationIterator; }
/* harmony export */ });
/* unused harmony export Pagination */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74001);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var lodash_sum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47304);
/* harmony import */ var lodash_sum__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_sum__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8801);
/* harmony import */ var _layout_List__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43481);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30208);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  overflow: auto;\n\n  li {\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  > * + * {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var Pagination = function(param) {
    var query = param.query, children = param.children;
    var ref = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__/* .useInView */ .YD)(), ref1 = ref.ref, inView = ref.inView;
    var hasNextPage = query.hasNextPage, isFetchingNextPage = query.isFetchingNextPage, fetchNextPage = query.fetchNextPage;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isFetchingNextPage && hasNextPage && inView) {
            fetchNextPage();
        }
    }, [
        hasNextPage,
        isFetchingNextPage,
        inView,
        fetchNextPage
    ]);
    return hasNextPage ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        ref: ref1,
        onClick: isFetchingNextPage ? undefined : function() {
            return fetchNextPage();
        },
        children: children
    }) : null;
};
/* harmony default export */ __webpack_exports__["ZP"] = (Pagination);
var horizontalCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xsmall */ .Ki.xsmall);
var PaginationIterator = function(param) {
    var className = param.className, name = param.name, query = param.query, ad = param.ad, inFeedAd = param.inFeedAd, _inFeedAdInterval = param.inFeedAdInterval, inFeedAdInterval = _inFeedAdInterval === void 0 ? 4 : _inFeedAdInterval, _inFeedAdStart = param.inFeedAdStart, inFeedAdStart = _inFeedAdStart === void 0 ? 2 : _inFeedAdStart, border = param.border, margin = param.margin, _identifier = param.identifier, identifier = _identifier === void 0 ? "id" : _identifier, _direction = param.direction, direction = _direction === void 0 ? "vertical" : _direction, _next = param.next, next = _next === void 0 ? true : _next, prevComponent = param.prevComponent, _$css = param.css, children = param.children;
    var ref;
    var isError = query.isError, data = query.data;
    if (isError) {
        return null;
    }
    var ref1;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_layout_List__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: className,
                css: _$css ? _$css : direction === "horizontal" ? horizontalCSS : undefined,
                border: border,
                margin: margin,
                children: [
                    ad && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                        children: ad
                    }),
                    prevComponent && prevComponent,
                    (ref1 = data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.map(function(page, i) {
                        var ref;
                        var _lastEvaluatedKey;
                        var key = "page" in page ? page.page : (_lastEvaluatedKey = page.lastEvaluatedKey) !== null && _lastEvaluatedKey !== void 0 ? _lastEvaluatedKey : page.next;
                        var ref1;
                        var prevItemLength = lodash_sum__WEBPACK_IMPORTED_MODULE_2___default()(data === null || data === void 0 ? void 0 : data.pages.map(function(p) {
                            var ref;
                            return (ref1 = (ref = p.items) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0;
                        }).slice(0, i));
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: (ref = page.items) === null || ref === void 0 ? void 0 : ref.map(function(item, j) {
                                var rendered = children(item, prevItemLength + j, i);
                                var globalIndex = prevItemLength + j;
                                var showInFeedAd = inFeedAd && inFeedAdInterval > 0 && globalIndex + 1 >= inFeedAdStart && (globalIndex + 1 - inFeedAdStart) % inFeedAdInterval === 0;
                                if (rendered) {
                                    var _identifier;
                                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                                                children: rendered
                                            }),
                                            showInFeedAd && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                                                children: inFeedAd
                                            })
                                        ]
                                    }, "".concat(name, "-").concat(key, "-").concat((_identifier = item[identifier]) !== null && _identifier !== void 0 ? _identifier : (0,uuid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)()));
                                }
                                return null;
                            })
                        }, "".concat(name, "-").concat(key));
                    })) !== null && ref1 !== void 0 ? ref1 : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        push: true
                    }),
                    direction === "horizontal" && next && query.hasNextPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Pagination, {
                            query: query,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                size: 6
                            })
                        })
                    })
                ]
            }),
            direction === "vertical" && next && query.hasNextPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Pagination, {
                query: query,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {})
            })
        ]
    });
};


/***/ }),

/***/ 66889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(71618);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54909);
/* harmony import */ var _api_chatbot__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23082);
/* harmony import */ var _api_story__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10741);
/* harmony import */ var _api_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9622);
/* harmony import */ var _components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11247);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30259);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82740);
/* harmony import */ var _utils_chat__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42127);
/* harmony import */ var _utils_mention__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68406);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81946);
/* harmony import */ var _common_Avatar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81649);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  margin-top: ",
        "px;\n\n  &:empty {\n    display: none;\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n  padding: ",
        "px;\n  border-radius: ",
        "px;\n  border: 1px solid ",
        ";\n  background: linear-gradient(\n    180deg,\n    #ffffff 0%,\n    ",
        " 100%\n  );\n  text-align: left;\n\n  &:active {\n    background: ",
        ";\n  }\n\n  .thumb {\n    position: relative;\n    width: 56px;\n    height: 56px;\n    overflow: hidden;\n    flex-shrink: 0;\n    border-radius: ",
        "px;\n    background: ",
        ";\n  }\n\n  .meta {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    flex: 1;\n    gap: 2px;\n  }\n\n  .eyebrow {\n    display: inline-flex;\n    align-items: center;\n    width: fit-content;\n    padding: 2px 6px;\n    border-radius: 999px;\n    background: ",
        ";\n    color: ",
        ";\n    ",
        ";\n    font-weight: 600;\n  }\n\n  .title {\n    ",
        ";\n    font-weight: 700;\n    color: ",
        ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .description {\n    ",
        ";\n    color: ",
        ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .stats {\n    ",
        ";\n    color: ",
        ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .chevron {\n    flex-shrink: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


















var listCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Spacing.small */ .Ki.small);
var cardButtonCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Radius.medium */ .wU.medium, theme.var.gray100, theme.var.gray50, theme.var.gray50, chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Radius.small */ .wU.small, theme.var.gray100, theme.colors.main50, theme.colors.main500, chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Typography.body11 */ .ZT.body11, chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Typography.body14 */ .ZT.body14, theme.var.gray900, chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Typography.body12 */ .ZT.body12, theme.var.gray600, chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Typography.body11 */ .ZT.body11, theme.var.gray500);
};
var userThumbWrapCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)(_templateObject2());
var fallbackThumbCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)(_templateObject3(), theme.var.gray100, theme.var.gray400, chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Typography.body12 */ .ZT.body12);
};
var getMentionEyebrow = function(type) {
    switch(type){
        case "u":
            return "유저";
        case "s":
            return "작품";
        case "c":
            return "캐릭터";
    }
};
var MentionCardItem = function(param) {
    var mention = param.mention;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.u)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_9__/* .useGlobalContext */ .bN)().platform;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_13__/* .useWebView */ .B9)().web;
    var navigate = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(path) {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_8__/* .Platform.web */ .t4.web) {
            router.push(path);
        } else {
            web.openPage(path);
        }
    }, [
        platform,
        router,
        web
    ]);
    var userQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_8__/* .QUERY_KEYS.USER.ONE */ .U7.USER.ONE(mention.id), function() {
        return (0,_api_user__WEBPACK_IMPORTED_MODULE_6__/* .fetchUser */ .BT)(mention.id);
    }, {
        enabled: mention.type === "u",
        suspense: false,
        useErrorBoundary: false,
        retry: false,
        staleTime: 60 * 1000
    });
    var storyQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_8__/* .QUERY_KEYS.STORY.ONE */ .U7.STORY.ONE(mention.id), function() {
        return (0,_api_story__WEBPACK_IMPORTED_MODULE_5__/* .fetchStory */ .su)(mention.id);
    }, {
        enabled: mention.type === "s",
        suspense: false,
        useErrorBoundary: false,
        retry: false,
        staleTime: 60 * 1000
    });
    var characterQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_8__/* .QUERY_KEYS.CHARACTER.ONE */ .U7.CHARACTER.ONE(mention.id), /*#__PURE__*/ _asyncToGenerator(function() {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_api_chatbot__WEBPACK_IMPORTED_MODULE_4__/* .getCharacterDetail */ ._t)(mention.id)
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    }), {
        enabled: mention.type === "c",
        staleTime: 60 * 1000
    });
    var card = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref, ref1;
        if (mention.type === "u") {
            var user = userQuery.data;
            if (!user) {
                return null;
            }
            return {
                title: user.nickname,
                description: user.introduce || t("유저 프로필 보기"),
                stats: "".concat(t("팔로워"), " ").concat(t("formatNumber", {
                    val: user.followerCount || 0
                }), " \xb7 ").concat(t("작품"), " ").concat(t("formatNumber", {
                    val: user.storyCount || 0
                })),
                thumb: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("div", {
                    css: userThumbWrapCSS,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_common_Avatar__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, _objectSpread({
                        size: _common_Avatar__WEBPACK_IMPORTED_MODULE_14__/* .AvatarSize.large */ .DZ.large
                    }, user))
                })
            };
        }
        if (mention.type === "s") {
            var story = storyQuery.data;
            if (!story) {
                return null;
            }
            return {
                title: story.title,
                description: story.summary || story.user.nickname,
                stats: "".concat(story.user.nickname, " \xb7 ").concat(t("탭"), " ").concat(t("formatNumber", {
                    val: story.tapCount || 0
                })),
                thumb: story.coverImage ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    image: story.coverImage,
                    alt: story.title
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("div", {
                    css: fallbackThumbCSS(theme),
                    children: t("작품")
                })
            };
        }
        var character = characterQuery.data;
        if (!character) {
            return null;
        }
        return {
            title: character.name,
            description: character.summary || t("캐릭터 프로필 보기"),
            stats: "".concat(t("플레이"), " ").concat((0,_utils_chat__WEBPACK_IMPORTED_MODULE_12__/* .formatNumberMillion */ .OQ)(((ref = character.stat) === null || ref === void 0 ? void 0 : ref.message_count) || 0), " \xb7 ").concat(t("좋아요"), " ").concat(t("formatNumber", {
                val: ((ref1 = character.stat) === null || ref1 === void 0 ? void 0 : ref1.like_count) || 0
            })),
            thumb: character.profile_image || character.cover_image ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                image: character.profile_image || character.cover_image,
                alt: character.name
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("div", {
                css: fallbackThumbCSS(theme),
                children: t("캐릭터")
            })
        };
    }, [
        characterQuery.data,
        mention.type,
        storyQuery.data,
        t,
        theme,
        userQuery.data
    ]);
    if (!card) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("button", {
        type: "button",
        css: cardButtonCSS(theme),
        onClick: function(e) {
            e.stopPropagation();
            navigate((0,_utils_mention__WEBPACK_IMPORTED_MODULE_18__/* .getMentionPath */ .SO)(mention));
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("div", {
                className: "thumb",
                children: card.thumb
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("div", {
                className: "meta",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("span", {
                        className: "eyebrow",
                        children: getMentionEyebrow(mention.type)
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("strong", {
                        className: "title",
                        children: card.title
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("span", {
                        className: "description",
                        children: card.description
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("span", {
                        className: "stats",
                        children: card.stats
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("span", {
                className: "chevron",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_11__/* .Icon */ .JO, {
                    icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_11__/* .ArrowRight */ .ol,
                    size: chatie_design_system__WEBPACK_IMPORTED_MODULE_10__/* .Sizes.small */ .u8.small,
                    color: theme.var.gray400
                })
            })
        ]
    });
};
var MentionCards = function(param) {
    var content = param.content, className = param.className;
    var mentions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,_utils_mention__WEBPACK_IMPORTED_MODULE_18__/* .extractUniqueMentions */ .TJ)(content);
    }, [
        content
    ]);
    if (!mentions.length) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("div", {
        css: listCSS,
        className: className,
        children: mentions.map(function(mention) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(MentionCardItem, {
                mention: mention
            }, "".concat(mention.type, ":").concat(mention.id));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MentionCards);


/***/ }),

/***/ 89831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54909);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9150);
/* harmony import */ var _api_community__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1385);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n  border: 1px solid ",
        ";\n  border-radius: ",
        "px;\n  padding: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        border-color: ",
        ";\n        font-weight: 600;\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n        &:active {\n          border-color: ",
        ";\n          background-color: ",
        ";\n        }\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n        background-color: ",
        ";\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100%;\n      text-align: left;\n      padding: 10px ",
        "px;\n      border: 1px solid\n        ",
        ";\n      border-radius: ",
        "px;\n      ",
        ";\n      cursor: ",
        ";\n      position: relative;\n      overflow: hidden;\n      background-color: transparent;\n\n      ",
        "\n\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: ",
        "%;\n      background-color: ",
        ";\n      transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n      border-radius: ",
        "px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 1;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n  min-width: 0;\n  flex: 1;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 14px;\n  flex-shrink: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    color: ",
        ";\n    flex-shrink: 0;\n    margin-left: ",
        "px;\n    font-weight: ",
        ";\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n  min-width: 0;\n  flex: 1;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: 2px;\n\n  &::before {\n    content: '\xb7';\n    margin: 0 2px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n  font-weight: 600;\n  flex-shrink: 0;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        "px ",
        "px;\n  border-radius: ",
        "px;\n  background-color: ",
        ";\n  color: ",
        ";\n  ",
        ";\n  font-weight: 600;\n  flex-shrink: 0;\n\n  &:disabled {\n    background-color: ",
        ";\n    cursor: not-allowed;\n  }\n\n  &:active:not(:disabled) {\n    opacity: 0.85;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}







var wrapperCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, theme.border.light, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.medium */ .wU.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium);
};
var optionsListCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small);
var optionBtnCSS = function(isSelected, showResult, isWinner) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject5(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, isSelected ? theme.colors.main500 : theme.border.light, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.small */ .wU.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body14 */ .ZT.body14, showResult ? "default" : "pointer", isWinner && showResult && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject2(), theme.colors.main500), !showResult && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject3(), theme.colors.main500, theme.colors.main50), !showResult && isSelected && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject4(), theme.colors.main50));
    };
};
var optionBarCSS = function(percentage, isWinner) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject6(), percentage, isWinner ? theme.colors.main100 : theme.var.gray100, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.small */ .wU.small);
    };
};
var optionContentCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject7());
var optionTextCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject8(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall);
var checkMarkCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject9(), theme.colors.main500);
};
var voteCountCSS = function(isWinner) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject10(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12, isWinner ? theme.colors.main500 : theme.var.gray500, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, isWinner ? 600 : 400);
    };
};
var footerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject11(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small);
var footerLeftCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject12(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall);
var totalVotesCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject13(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12, theme.var.gray500);
};
var remainingTimeCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject14(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12, theme.var.gray400);
};
var closedBadgeCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject15(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body12 */ .ZT.body12, theme.var.gray400);
};
var voteBtnCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject16(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radius.medium */ .wU.medium, theme.colors.main500, theme.true.white, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography.body14 */ .ZT.body14, theme.var.gray300);
};
function formatRemainingTime(endsAt, t) {
    var now = new Date();
    var end = new Date(endsAt);
    var diffMs = end.getTime() - now.getTime();
    if (diffMs <= 0) return null;
    var days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    var hours = Math.floor(diffMs % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(diffMs % (1000 * 60 * 60) / (1000 * 60));
    if (days > 0) {
        return hours > 0 ? "".concat(days).concat(t("일"), " ").concat(hours).concat(t("시간"), " ").concat(t("남음")) : "".concat(days).concat(t("일"), " ").concat(t("남음"));
    }
    if (hours > 0) {
        return minutes > 0 ? "".concat(hours).concat(t("시간"), " ").concat(minutes).concat(t("분"), " ").concat(t("남음")) : "".concat(hours).concat(t("시간"), " ").concat(t("남음"));
    }
    if (minutes > 0) {
        return "".concat(minutes).concat(t("분"), " ").concat(t("남음"));
    }
    return t("곧 마감");
}
var PollDisplay = function(param) {
    var poll = param.poll, communityId = param.communityId, onVote = param.onVote;
    var _Math;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedOptionId = ref[0], setSelectedOptionId = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), setTick = ref1[1];
    // 잔여시간 1분마다 갱신
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!poll.endsAt || poll.isClosed) return;
        var interval = setInterval(function() {
            return setTick(function(n) {
                return n + 1;
            });
        }, 60000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        poll.endsAt,
        poll.isClosed
    ]);
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useMutation)(function(optionId) {
        return (0,_api_community__WEBPACK_IMPORTED_MODULE_4__/* .voteCommunityPoll */ .Ak)(communityId, optionId);
    }, {
        onSuccess: function(data) {
            onVote === null || onVote === void 0 ? void 0 : onVote(data.poll, data.myVoteOptionId);
        }
    }), vote = ref2.mutate, isVoting = ref2.isLoading;
    var hasVoted = poll.myVoteOptionId !== null;
    var showResult = hasVoted || poll.isClosed || poll.canViewResult;
    var _voteCount;
    var totalVotes = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return poll.options.reduce(function(sum, opt) {
            return sum + ((_voteCount = opt.voteCount) !== null && _voteCount !== void 0 ? _voteCount : 0);
        }, 0);
    }, [
        poll.options
    ]);
    var _voteCount1;
    var maxVoteCount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (_Math = Math).max.apply(_Math, _toConsumableArray(poll.options.map(function(opt) {
            return (_voteCount1 = opt.voteCount) !== null && _voteCount1 !== void 0 ? _voteCount1 : 0;
        })));
    }, [
        poll.options
    ]);
    var getPercentage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(voteCount) {
        if (!totalVotes || voteCount === null) return 0;
        return Math.round(voteCount / totalVotes * 100);
    }, [
        totalVotes
    ]);
    var handleOptionClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(optionId) {
        if (showResult || poll.isClosed) return;
        setSelectedOptionId(optionId);
    }, [
        showResult,
        poll.isClosed
    ]);
    var handleVote = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!selectedOptionId || isVoting) return;
        vote(selectedOptionId);
    }, [
        selectedOptionId,
        isVoting,
        vote
    ]);
    var remainingText = poll.endsAt && !poll.isClosed ? formatRemainingTime(poll.endsAt, t) : null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        css: wrapperCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                css: optionsListCSS,
                children: poll.options.map(function(option) {
                    var isSelected = showResult ? option.id === poll.myVoteOptionId : option.id === selectedOptionId;
                    var percentage = getPercentage(option.voteCount);
                    var _voteCount;
                    var isWinner = showResult && totalVotes > 0 && ((_voteCount = option.voteCount) !== null && _voteCount !== void 0 ? _voteCount : 0) === maxVoteCount;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("button", {
                        type: "button",
                        css: optionBtnCSS(isSelected, showResult, isWinner),
                        onClick: function() {
                            return handleOptionClick(option.id);
                        },
                        disabled: showResult,
                        children: [
                            showResult && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                                css: optionBarCSS(percentage, isWinner)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                                css: optionContentCSS,
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                                        css: optionTextCSS,
                                        children: [
                                            isSelected && showResult && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                                                css: checkMarkCSS,
                                                children: "✓"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                                                children: option.content
                                            })
                                        ]
                                    }),
                                    showResult && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("span", {
                                        css: voteCountCSS(isWinner),
                                        children: [
                                            percentage,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, option.id);
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                css: footerCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                        css: footerLeftCSS,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                                css: totalVotesCSS,
                                children: showResult ? t("{{count}}명 투표", {
                                    count: totalVotes
                                }) : ""
                            }),
                            remainingText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                                css: remainingTimeCSS,
                                children: remainingText
                            })
                        ]
                    }),
                    poll.isClosed ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                        css: closedBadgeCSS,
                        children: t("마감됨")
                    }) : !hasVoted && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                        type: "button",
                        css: voteBtnCSS,
                        disabled: !selectedOptionId || isVoting,
                        onClick: handleVote,
                        children: t("투표하기")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PollDisplay);


/***/ }),

/***/ 95833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    padding-left: ",
        "px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    padding-right: ",
        "px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    padding-top: ",
        "px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    padding-bottom: ",
        "px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    border: 1px solid ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n  \n  ",
        "\n  \n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var padCSS = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, left = ref.left, right = ref.right, top = ref.top, bottom = ref.bottom, color = arguments.length > 1 ? arguments[1] : void 0, borderColor = arguments.length > 2 ? arguments[2] : void 0, backgroundColor = arguments.length > 3 ? arguments[3] : void 0;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject7(), left !== undefined && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), left), right !== undefined && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), right), top !== undefined && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2(), top), bottom !== undefined && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject3(), bottom), color && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject4(), color), borderColor && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject5(), borderColor), backgroundColor && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject6(), backgroundColor));
};
var Pad = function(param) {
    var className = param.className, _size = param.size, size = _size === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium : _size, tmp = param.sizes, ref = tmp === void 0 ? {} : tmp, left = ref.left, right = ref.right, top = ref.top, bottom = ref.bottom, fillHorizontal = param.fillHorizontal, fillVertical = param.fillVertical, color = param.color, borderColor = param.borderColor, backgroundColor = param.backgroundColor, children = param.children, onClick = param.onClick;
    var ref1, ref2, ref3, ref4;
    var directions = {
        left: (ref1 = fillHorizontal ? 0 : left) !== null && ref1 !== void 0 ? ref1 : size,
        right: (ref2 = fillHorizontal ? 0 : right) !== null && ref2 !== void 0 ? ref2 : size,
        top: (ref3 = fillVertical ? 0 : top) !== null && ref3 !== void 0 ? ref3 : size,
        bottom: (ref4 = fillVertical ? 0 : bottom) !== null && ref4 !== void 0 ? ref4 : size
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        css: padCSS(directions, color, borderColor, backgroundColor),
        className: className,
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pad);


/***/ }),

/***/ 11502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11717);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26410);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9150);
/* harmony import */ var _components_common_Overlay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90814);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96964);
/* eslint-disable no-undef */ function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: rgba(0, 0, 0, 0.8) !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  overflow: scroll;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  touch-action: pan-x;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  overflow: hidden;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.6);\n  color: ",
        ";\n  ",
        ";\n  padding: 4px 12px;\n  border-radius: ",
        "px;\n  z-index: 2;\n  pointer-events: none;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.3);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  font-size: 20px;\n  z-index: 3;\n  cursor: pointer;\n\n  &:active {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  left: 8px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  right: 8px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}







var containerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), (0,_styles_css__WEBPACK_IMPORTED_MODULE_4__/* .safeArea */ .BI)("top", "padding"), (0,_styles_css__WEBPACK_IMPORTED_MODULE_4__/* .safeArea */ .BI)("bottom", "padding"));
var imageContainerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject1());
var galleryContainerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject2());
var galleryImageWrapCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject3());
var counterCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject4(), theme.true.white, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body14 */ .ZT.body14, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Radius.round */ .wU.round);
};
var navButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject5());
var prevButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject6(), navButtonCSS);
var nextButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject7(), navButtonCSS);
var ImageModal = function(_param) {
    var image = _param.image, imagesProp = _param.images, _initialIndex = _param.initialIndex, initialIndex = _initialIndex === void 0 ? 0 : _initialIndex, props = _objectWithoutProperties(_param, [
        "image",
        "images",
        "initialIndex"
    ]);
    var onClose = props.onClose, open = props.open;
    var images = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (imagesProp === null || imagesProp === void 0 ? void 0 : imagesProp.length) return imagesProp;
        if (image === null || image === void 0 ? void 0 : image.key) return [
            image
        ];
        return [];
    }, [
        imagesProp,
        image
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialIndex), currentIndex = ref[0], setCurrentIndex = ref[1];
    // 모달이 열릴 때마다 initialIndex로 리셋
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(open), prevOpen = ref1[0], setPrevOpen = ref1[1];
    if (open !== prevOpen) {
        setPrevOpen(open);
        if (open) {
            setCurrentIndex(initialIndex);
        }
    }
    var currentImage = images[currentIndex];
    var handlePrev = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        e.stopPropagation();
        setCurrentIndex(function(prev) {
            return Math.max(0, prev - 1);
        });
    }, []);
    var handleNext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(// eslint-disable-next-line no-undef
    function(e) {
        e.stopPropagation();
        setCurrentIndex(function(prev) {
            return Math.min(images.length - 1, prev + 1);
        });
    }, [
        images.length
    ]);
    // 스와이프 핸들링
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), touchStartX = ref2[0], setTouchStartX = ref2[1];
    var handleTouchStart = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        setTouchStartX(e.touches[0].clientX);
    }, []);
    var handleTouchEnd = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        if (touchStartX === null) return;
        var diff = e.changedTouches[0].clientX - touchStartX;
        var threshold = 50;
        if (diff > threshold && currentIndex > 0) {
            setCurrentIndex(function(prev) {
                return prev - 1;
            });
        } else if (diff < -threshold && currentIndex < images.length - 1) {
            setCurrentIndex(function(prev) {
                return prev + 1;
            });
        }
        setTouchStartX(null);
    }, [
        touchStartX,
        currentIndex,
        images.length
    ]);
    if (!open || images.length === 0) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {});
    }
    // 단일 이미지 모드
    if (images.length === 1 && currentImage) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_common_Overlay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({}, props), {
            blocking: false,
            css: containerCSS,
            onClosePageClick: onClose,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                css: imageContainerCSS,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
                    src: currentImage.attachment.url,
                    alt: "post-image",
                    layout: "intrinsic",
                    loader: function(param) {
                        var src = param.src;
                        return src;
                    },
                    width: currentImage.attachment.width,
                    height: currentImage.attachment.height,
                    objectPosition: "center",
                    objectFit: "contain"
                })
            })
        }));
    }
    // 멀티이미지 갤러리 모드
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_common_Overlay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({}, props), {
        blocking: false,
        css: containerCSS,
        onClosePageClick: onClose,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            css: galleryContainerCSS,
            onTouchStart: handleTouchStart,
            onTouchEnd: handleTouchEnd,
            children: [
                currentIndex > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                    css: prevButtonCSS,
                    onClick: handlePrev,
                    children: "‹"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                    css: galleryImageWrapCSS,
                    children: currentImage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
                        src: currentImage.attachment.url,
                        alt: "post-image-".concat(currentIndex + 1),
                        layout: "intrinsic",
                        loader: function(param) {
                            var src = param.src;
                            return src;
                        },
                        width: currentImage.attachment.width,
                        height: currentImage.attachment.height,
                        objectPosition: "center",
                        objectFit: "contain"
                    }, "modal-img-".concat(currentIndex))
                }),
                currentIndex < images.length - 1 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                    css: nextButtonCSS,
                    onClick: handleNext,
                    children: "›"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                    css: counterCSS,
                    children: [
                        currentIndex + 1,
                        " / ",
                        images.length
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageModal);


/***/ }),

/***/ 85791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getPostImages; }
/* harmony export */ });
/**
 * 포스트에서 이미지 배열을 추출하는 헬퍼.
 * pictures 배열이 있으면 우선 사용하고, 없으면 picture 단일 필드로 fallback.
 */ var getPostImages = function(post) {
    var ref, ref1;
    if ((ref = post.pictures) === null || ref === void 0 ? void 0 : ref.length) return post.pictures;
    if ((ref1 = post.picture) === null || ref1 === void 0 ? void 0 : ref1.key) return [
        post.picture
    ];
    return [];
};


/***/ })

}]);